export default "__VITE_ASSET__2jTb_OmS8gH2XrKVmYYxFA__"